import React from 'react';
export interface ProductListProps {
  children?: React.ReactNode;
  className?: string;
  'data-testid'?: string;
  'data-trk-rec-list-id'?: string;
  'data-trk-rec-list-fallback'?: boolean;
}
const ProductList = ({
  children,
  ...rest
}: ProductListProps) => {
  return <div data-testid="ProductList" {...rest} data-sentry-component="ProductList" data-sentry-source-file="ProductList.tsx">
      {children}
    </div>;
};
export default ProductList;